import { useState, useEffect, useRef } from "react";

const LazyMedia = ({ media }) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

  useEffect(() => {
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          io.unobserve(entry.target);
        }
      },
      { rootMargin: "200px" }
    );
    if (ref.current) io.observe(ref.current);
    return () => io.disconnect();
  }, []);

  // iOS fallback - if video hasn't loaded after 1s, force it
  useEffect(() => {
    if (!visible || !isIOS || media.type !== "video") return;
    const timer = setTimeout(() => setLoaded(true), 1000);
    return () => clearTimeout(timer);
  }, [visible, isIOS, media.type]);

  const fadeStyle = {
    opacity: loaded ? 1 : 0,
    transition: "opacity .35s ease",
    width: "100%",
    height: "100%",
    objectFit: "cover",
  };

  return (
    <div ref={ref} className="lazy-wrapper">
      {!loaded && <div className="skeleton" />}
      {visible && (
        <div className="media-container">
          {media.type === "video" ? (
            <>
              <video
                src={media.url}
                muted
                autoPlay
                loop
                preload={isIOS ? "none" : "metadata"}
                style={fadeStyle}
                onLoadedData={() => setLoaded(true)}
                playsInline
                controls={false}
                webkit-playsinline="true"
                x-webkit-airplay="allow"
                x5-video-player-type="h5"
                x5-video-player-fullscreen="false"
                x5-video-orientation="portrait"
              />
            </>
          ) : (
            <img
              src={media.url}
              alt={media.name}
              loading="lazy"
              style={fadeStyle}
              onLoad={() => setLoaded(true)}
            />
          )}
          <img
            src="/images/datlogoA.png"
            className="watermark"
            alt="DAT logo watermark"
          />
        </div>
      )}
    </div>
  );
};

export default LazyMedia;